import axios from "../config/axios"

// Version control of registry projects: the versions (ProjectVersionDTO) of every sub project of a project
export const ProjectVersionRepository = {
  // newest first; type: STAGE | PRODUCTION, left out = every type
  getByProject: (projectId, type) => {
    return axios.get(`/api/project-version/project/${projectId}`, {params: type ? {type} : {}});
  },
}
